import React, { PureComponent } from 'react'
import {connect} from "react-redux";

import * as actions from "../../store/actions/actions";
import Header from "../../components/Headers/Header";
import {Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Row} from "reactstrap";
import {FormControl} from "react-bootstrap";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import {isCorporateEditableForCampaign}  from "../../store/actions/roles";
import * as Roles from "../../store/actions/roles";

import italianCampaignCreateTranslations from "../../translations/campaign/create/it.campaign.create.json";
import englishCampaignCreateTranslations from "../../translations/campaign/create/en.campaign.create.json";

class CampaignCreate extends PureComponent {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianCampaignCreateTranslations, "it");
    this.props.addTranslationForLanguage(englishCampaignCreateTranslations, "en");
  }

  componentDidMount() {
    this.props.fetchCorporates()
    if(this.props.authenticatedUserRole !== Roles.BANK_ADMIN){
      this.props.checkAuthType(this.props.idBank,this.props.userCorporateSenderId)
    }else if(this.props.authenticatedUserRole === Roles.BANK_ADMIN){

      if(null !== this.props.corporate && "" !== this.props.corporate){
        this.props.checkAuthType(this.props.idBank,this.props.corporate)
      }
    }
  }

  onBackClick = () => {
    this.props.history.goBack();
  }

  submitHandler = async (event) => {
    event.preventDefault();
    let bankId=this.props.idBank;
    let data = {
      corporate: this.props.corporate,
      campaignName: this.props.campaignName,
      campaignLogo: this.props.campaignLogo,
      enabled: this.props.enabled,
      authorizationType:this.props.authorizationType,
    }
    this.props.saveCampaign(data,bankId)
  }

  updateAuthType=()=>{
    if(""!== this.props.corporate && undefined !== this.props.corporate && null !== this.props.corporate){
      this.props.checkAuthType(this.props.idBank,this.props.corporate)
    }
  }

  render() {
    let role = this.props.authenticatedUserRole;
    if(role===Roles.BANK_ADMIN){
      this.updateAuthType();
    }
    let corporateDisabled=true;
    corporateDisabled=isCorporateEditableForCampaign(role);
    let errors="";
    errors=this.props.validationError;
    let campaignNameError = ""
    let campaignLogoError = ""
    let corporateSenderIdError=""
    if(errors !== null && errors !== "" && errors !== undefined){
      if(errors.data.length>0){
        errors.data.map((item) =>{
          if(item.field === 'campaignName')
            campaignNameError=item.defaultMessage;
          if(item.field === 'corporate')
            corporateSenderIdError=item.defaultMessage;
          if(item.field === 'campaignLogo')
            campaignLogoError=item.defaultMessage;
          return ""
        });
      }
    }

    let corporateAuthType=this.props.corporateAuthType

    let singleAuthDisabled = true,doubleAuthDisabled=true;
    if(corporateAuthType !== null && corporateAuthType !== "" && corporateAuthType !== undefined){
      if(corporateAuthType === "SINGLE_AUTHORIZATION"){
        singleAuthDisabled=false;
      }else if(corporateAuthType === "DOUBLE_AUTHORIZATION"){
        singleAuthDisabled=false;
        doubleAuthDisabled=false;
      }else if(corporateAuthType === "NO_AUTHORIZER"){
        singleAuthDisabled=true;
        doubleAuthDisabled=true;
      }
    }

    return (
        <>
          <Header />
          <Container className="mt--5" fluid>
            <Row>
              <div className="col" style={{paddingBottom:"2%"}}>
                <Card className="shadow">
                  <CardHeader className="border-0">
                    <Row>
                      <div className="col">
                        <h3 className="mb-0">
                          <Translate id="campaign.create.title"/>
                        </h3>
                      </div>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={this.submitHandler}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="campaignName">
                                <Translate id="campaign.create.campaign.name"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className={campaignNameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  value={this.props.campaignName}
                                  onChange={this.onCampaignNameChange}
                                  id="campaignName"
                                  placeholder={translate("campaign.create.campaign.name")}
                                  type="text"/>}
                              </Translate>
                              { campaignNameError.length > 0 ? <label style={{color:"red"}}><Translate id={campaignNameError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporate">
                                <Translate id="campaign.create.corporate" />
                              </label>
                              <FormControl className={corporateSenderIdError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' } as="select"
                                           onChange={(newValue) => {
                                             this.onCorporateChange(newValue.target.value);
                                           }}
                                           disabled={corporateDisabled}
                                           required={true}
                              >
                                <option></option>
                                {this.props.corporates.map((item)=>{
                                  if(item.corporateSenderId===this.props.userCorporateSenderId){
                                    this.onCorporateChange(item.corporateSenderId)
                                    return <option value={item.corporateSenderId} selected="selected">{item.corporateSenderName}</option>
                                  }else{
                                    return <option value={item.corporateSenderId}>{item.corporateSenderName}</option>
                                  }

                                })}
                              </FormControl>
                              { corporateSenderIdError.length > 0 ? <label style={{color:"red"}}><Translate id={corporateSenderIdError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="files">
                                <Translate id="campaign.create.logo"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                    className={campaignLogoError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                    onChange={this.onCampaignLogoChange}
                                    id="files"
                                    placeholder={translate("campaign.create.logo")}
                                    type="file"/>}
                              </Translate>
                              <span>
                                <small>
                                  <Translate id="campaign.create.logo.size"/>
                                </small>
                              </span>
                              { campaignLogoError.length > 0 ? <label style={{color:"red"}}><Translate id={campaignLogoError}/></label> : "" }
                              </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="Authorizers">
                                <Translate id="campaign.create.campaign.authorizers"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                    <FormControl className={corporateSenderIdError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' } as="select"
                                                 onChange={(newValue) => {
                                                   this.onAuthorizerChange(newValue.target.value);
                                                 }}
                                                 required={true}
                                    >
                                      <option></option>
                                      <option value="SINGLE_AUTHORIZATION" disabled={singleAuthDisabled}>{translate("campaign.create.campaign.single.authorization")}</option>
                                      <option value="DOUBLE_AUTHORIZATION" disabled={doubleAuthDisabled}>{translate("campaign.create.campaign.double.authorization")}</option>
                                    </FormControl>}
                              </Translate>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col align="left">
                            <Button onClick={this.onBackClick} variant="contained">
                              <i className="fas fa-arrow-left text-primary" />
                            </Button>
                          </Col>
                          <Col align="right">
                            <Button  type="submit" className="btn-success" variant="contained" >
                              <Translate id="campaign.create.save.button"/>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </form>
                  </CardBody>
                </Card>
              </div>
            </Row>
          </Container>
        </>
    );
  }

  onCampaignLogoChange = async (event) => {
    let image = event.target.files[0]
    event.preventDefault();
    let toBase64 = file => new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
    this.props.campaignLogoChange(await toBase64(image))
  }

  onCorporateChange = (corporate) => {
    if(corporate !== '')
      this.props.corporateChange(corporate)
  }
  onAuthorizerChange = (authorizer) => {
    if(authorizer !== '')
      this.props.authorizersChange(authorizer)
  }


  onCampaignNameChange = (event) => {
    let campaignName = event.target.value
    this.props.campaignNameChange(campaignName)
  }

  onEnabledChange = (event) => {
    let enabled = event.target.value === "true" ? true : false
    this.props.enabledChange(enabled)
  }
}

const mapStateToProps = state => {
  return {
    corporates: state.corporate.corporates,
    corporate: state.campaignCreate.campaignToCreate.corporate,
    corporateAuthType: state.campaignCreate.corporateAuthType,
    campaignName: state.campaignCreate.campaignToCreate.campaignName,
    campaignLogo: state.campaignCreate.campaignToCreate.campaignLogo,
    authorizationType:state.campaignCreate.campaignToCreate.authorizationType,
    enabled: state.campaignCreate.campaignToCreate.enabled === true ? "true" : "false",
    validationError:state.campaignCreate.error,
    userCorporateSenderId: state.authentication.authenticatedUser.corporateSenderId,
    idBank:state.authentication.authenticatedUser.idBank,
    authenticatedUserRole: state.authentication.authenticatedUser.role,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    saveCampaign: (campaign,bankId) => dispatch({ type: actions.SAVE_CAMPAIGN_CREATE_REQUEST, value: {campaign:campaign,bankId:bankId}}),
    corporateChange: (corporate) => dispatch({ type: actions.CREATE_CAMPAIGN_CORPORATE_FILED_CHANGE_REQUEST, value: corporate }),
    campaignNameChange: (campaignName) => dispatch({ type: actions.CREATE_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE_REQUEST, value: campaignName }),
    campaignLogoChange: (campaignLogo) => dispatch({ type: actions.CREATE_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE_REQUEST, value: campaignLogo }),
    enabledChange: (enabled) => dispatch({ type: actions.CREATE_CAMPAIGN_ENABLED_FILED_CHANGE_REQUEST, value: enabled }),
    authorizersChange: (authorizers) => dispatch({ type: actions.CREATE_CAMPAIGN_AUTHORIZERS_CHANGE_REQUEST, value: authorizers }),
    checkAuthType:(bankId,corporate) => dispatch({ type: actions.CREATE_CAMPAIGN_AUTH_TYPE_CHECK_REQUEST, value: {corporate:corporate,bankId:bankId} }),
    fetchCorporates: () => dispatch({ type: actions.FETCH_CORPORATES_REQUEST })
  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(CampaignCreate));